import { Get } from '../requestBuilder/buildFetchRequest';
import PagedResponse from '../PagedResponse';
import HourType from './HourType';
import HourTypeQueryOptions from './HourTypesQueryOptions';
import HourTypeForTimecardQueryOptions from './HourTypesForTimecardQueryOptions';
import { QueryParameters, buildQueryParams } from '../QueryParameters';

export const getHourTypes = (query: QueryParameters<HourType, HourTypeQueryOptions>): Promise<PagedResponse<HourType>> => (
  Get('/api/hourTypes')
    .AddQueryParams(buildQueryParams(query))
    .Execute()
);

export const getHourTypesForTimecard = (query: QueryParameters<HourType, HourTypeForTimecardQueryOptions>): Promise<PagedResponse<HourType>> => {
  // eslint-disable-next-line prefer-const
  let q = { ...query } as any;
  if (q.filter?.projectId == null || q.filter?.projectId === undefined || q.filter?.projectId === '' || q.filter?.projectId === -1) delete q.filter?.projectId;
  if (q.filter?.specId == null || q.filter?.specId === undefined || q.filter?.specId === '' || q.filter?.specId === -1) delete q.filter?.specId;
  if (q.filter?.nonConformanceId == null || q.filter?.nonConformanceId === undefined || q.filter?.nonConformanceId === '' || q.filter?.nonConformanceId === -1) delete q.filter?.nonConformanceId;
  if (q.filter?.processScheduleDetailId == null || q.filter?.processScheduleDetailId === undefined || q.filter?.processScheduleDetailId === '' || q.filter?.processScheduleDetailId === -1) delete q.filter?.processScheduleDetailId;
  if (q.filter?.employeeId == null || q.filter?.employeeId === undefined || q.filter?.employeeId === '' || q.filter?.employeeId === -1) delete q.filter?.employeeId;
  return Get('/api/hourTypesForTimecards')
    .AddQueryParams(buildQueryParams(q))
    .Execute();
};

export const getHourType = (hourTypeId: number): Promise<HourType> => (
  Get(`/api/hourTypes/${hourTypeId}`)
    .Execute()
);
